import { notifications } from "@mantine/notifications";
import {
  IconCheck,
  IconFall,
  IconInfoCircle,
  IconNote,
  IconX,
} from "@tabler/icons-react";
// import Push from "push.js";
const _autoClose = 5000;
const _autoPushBrowser = 5000;
function Success(noti: string | undefined) {
  if (noti)
    //toast.success(noti, setting);
    notifications.show({
      title: "Thông báo",
      message: noti,
      withCloseButton: true,
      autoClose: _autoClose,
      // onClose: () => console.log('unmounted'),
      // onOpen: () => console.log('mounted'),
      color: "green",
      icon: <IconCheck />,
    });
}
function Fails(noti: React.ReactNode | string) {
  if (noti)
    notifications.show({
      title: "Thông báo",
      message: noti,
      withCloseButton: true,
      autoClose: _autoClose,
      // onClose: () => console.log('unmounted'),
      // onOpen: () => console.log('mounted'),
      color: "red",
      icon: <IconX />,
    });
  // toast.error(noti, setting);
}

function Info(noti: string) {
  if (noti)
    notifications.show({
      title: "Thông báo",
      message: noti,
      withCloseButton: true,
      autoClose: _autoClose,
      // onClose: () => console.log('unmounted'),
      // onOpen: () => console.log('mounted'),
      color: "",
      icon: <IconInfoCircle />,
    });
  // toast.info(noti, setting);
}

function Warn(noti: string) {
  if (noti)
    notifications.show({
      title: "Thông báo",
      message: noti,
      withCloseButton: true,
      autoClose: _autoClose,
      // onClose: () => console.log('unmounted'),
      // onOpen: () => console.log('mounted'),
      color: "orange",
      icon: <IconNote />,
    });
  // toast.info(noti, setting);
}

// Toast loading (có spinner) cho các thao tác async như tải file.
// Trả về { id, success, fail } để cập nhật khi hoàn tất / lỗi.
function Loading(message?: string, title: string = "Đang xử lý") {
  const id = "loading-" + Date.now() + "-" + Math.random().toString(36).slice(2);
  notifications.show({
    id,
    loading: true,
    title,
    message: message ?? "Vui lòng đợi...",
    autoClose: false,
    withCloseButton: false,
  });
  return {
    id,
    success: (msg?: string) =>
      notifications.update({
        id,
        loading: false,
        color: "green",
        title: "Hoàn tất",
        message: msg ?? "Thành công",
        icon: <IconCheck />,
        autoClose: _autoClose,
        withCloseButton: true,
      }),
    fail: (msg?: string) =>
      notifications.update({
        id,
        loading: false,
        color: "red",
        title: "Thông báo",
        message: msg ?? "Thất bại",
        icon: <IconX />,
        autoClose: _autoClose,
        withCloseButton: true,
      }),
  };
}

function PushBrowser(
  body?: string,
  title?: string,
  handle?: Function,
  icon?: string
) {
  // const status = Push.Permission.get();
  // const check = Push.Permission.has();
  // if (check && status !== Push.Permission.DENIED) {
  //   Push.Permission.request();
  //   Push.create(title ? title : "Thông báo !", {
  //     body: body,
  //     icon: icon
  //       ? icon
  //       : "https://hanoicomputercdn.com/media/lib/30-05-2024/favicon-hacom-2024.png",
  //     timeout: _autoPushBrowser, // Timeout before notification closes automatically.
  //     vibrate: true, // An array of vibration pulses for mobile devices.
  //     onClick: handle,
  //   });
  // } else Info("Xin vui lòng bật thông báo trên trình duyệt !");
}

export const NotificationExtension = {
  Success,
  Fails,
  Info,
  Warn,
  Loading,
  PushBrowser,
};
